export enum CompanyType {
    Lead,
    Syndicate
}
